import { useState } from 'react'

import { useHotkeys } from 'ui/hooks'

import { SearchButton } from './SearchButton'
import { SearchDialog } from './SearchDialog'

export const GlobalSearch = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const open = () => {
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
  }

  useHotkeys([
    {
      keys: ['/'],
      callback: open,
      preventDefault: true,
      blockOnInputWithFocus: true
    },
    {
      keys: ['Escape'],
      callback: close,
      preventDefault: true
    }
  ])

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
      <SearchButton onClick={open} />
      {isOpen && <SearchDialog onClose={close} />}
    </div>
  )
}
